export default function Impressum() {
  return <>Impressum</>;
}
